import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import type { UserCredentials, Profile, UserAgency } from "@/types/auth";

const isAuthenticated = ref<boolean>(false);
const headerProfile = ref<Profile | null>({ fullName: "", role: "Admin" });
const userAgency = ref<UserAgency | null>(null);
const isSuperAdmin = ref<boolean>(false);
const error = ref<Error | string | null>(null);


export default function useAuth() {
  const router = useRouter();
  const authStore = useAuthStore();

  const initAuth = () => {
    authStore.fetchAllTokens()
    const token = authStore.getAccessToken();
    if (token) {
      isAuthenticated.value = true;
    }
    const agency = authStore.getUserAgency();
    if (agency) userAgency.value = JSON.parse(agency) as UserAgency;

    const profile = authStore.getUserProfile();
    if (profile) headerProfile.value = JSON.parse(profile) as Profile;

    const superAdmin = authStore.isSuperAdmin();
    if (superAdmin) {
      isSuperAdmin.value = true;
    }
  };

  const login = async (loginDetails: UserCredentials) => {
    try {
      const response = await authStore.signIn(loginDetails);

      if (response.success) {
        isAuthenticated.value = true;

        const agency = authStore.getUserAgency();
        if (agency) userAgency.value = JSON.parse(agency) as UserAgency;

        const profile = authStore.getUserProfile();
        if (profile) headerProfile.value = JSON.parse(profile) as Profile;

        const superAdmin = authStore.isSuperAdmin();
        if (superAdmin) {
          isSuperAdmin.value = true;
        }
        return true;
      }

      return false;
    } catch {
      isAuthenticated.value = false;
      userAgency.value = null;
      headerProfile.value = null;
      isSuperAdmin.value = false;
      error.value = "Incorrect Email or Password";
      return false;
    }
  };

  const logout = () => {
    authStore.logout();
    isAuthenticated.value = false;
    userAgency.value = null;
    headerProfile.value = null;
    isSuperAdmin.value = false;
    router.push("/");
  };


  return {
    userAgency,
    isAuthenticated,
    isSuperAdmin,
    headerProfile,
    initAuth,
    login,
    logout
  };
}
